import { __extends } from "tslib";
import { AssetBase, } from '@awayjs/core';
/**
 * @class away.partition.Partition
 */
var PartitionBase = /** @class */ (function (_super) {
    __extends(PartitionBase, _super);
    function PartitionBase(rootNode) {
        var _this = _super.call(this) || this;
        _this._children = new Array();
        _this._updateQueue = {};
        _this.isUpdated = false;
        _this._rootNode = rootNode;
        return _this;
    }
    Object.defineProperty(PartitionBase.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PartitionBase.prototype, "rootNode", {
        get: function () {
            return this._rootNode;
        },
        enumerable: true,
        configurable: true
    });
    PartitionBase.prototype.addChild = function (child) {
        this._children.push(child);
        child.setParent(this);
        // this.updateNode(child.rootNode);
        if (!this._invalid)
            this.invalidate();
    };
    PartitionBase.prototype.removeChild = function (child) {
        //child.clear();
        this._children.splice(this._children.indexOf(child), 1)[0];
        child.setParent(null);
        // this._rootNode.removeNode(child.rootNode);
        if (!this._invalid)
            this.invalidate();
    };
    PartitionBase.prototype.setParent = function (parent) {
        this._parent = parent;
    };
    PartitionBase.prototype.traverse = function (traverser) {
        this.isUpdated = this._invalid;
        this._invalid = false;
        this._rootNode.acceptTraverser(traverser);
    };
    PartitionBase.prototype.invalidateEntity = function (entityNode) {
        if (!this._invalid)
            this.invalidate();
        this._updateQueue[entityNode.id] = entityNode;
    };
    PartitionBase.prototype.updateEntity = function (entityNode) {
        //TODO: remove reliance on view
        //required for controllers with autoUpdate set to true and queued events
        entityNode.entity._iInternalUpdate();
        this.updateNode(entityNode);
    };
    PartitionBase.prototype.updateNode = function (node) {
        //const targetNode: ContainerNode = this.findParentForNode(node);
        // if (targetNode && node.parent != targetNode) {
        // 	if (node.parent)
        // 		node.parent.removeNode(node);
        // 	targetNode.addNode(node);
        // }
    };
    PartitionBase.prototype.clearEntity = function (entityNode) {
        if (!this._invalid)
            this.invalidate();
        delete this._updateQueue[entityNode.id];
        // const node: INode = entity.getAbstraction<EntityNode>(this);
        // node.parent.removeNode(node);
    };
    /**
     *
     * @param entity
     * @returns {away.partition.NodeBase}
     */
    PartitionBase.prototype.findParentForNode = function (node) {
        return this._rootNode;
    };
    PartitionBase.prototype.updateEntities = function () {
        for (var key in this._updateQueue)
            this.updateEntity(this._updateQueue[key]);
        //clear updateQueue
        this._updateQueue = {};
    };
    PartitionBase.prototype.invalidate = function () {
        this._invalid = true;
        _super.prototype.invalidate.call(this);
        if (this._parent)
            this._parent.invalidate();
    };
    PartitionBase.prototype.clear = function () {
        _super.prototype.clear.call(this);
        for (var i = 0; i < this._children.length; i++)
            this._children[i].clear();
    };
    PartitionBase.prototype.dispose = function () {
    };
    // public _setScene(scene: IPartitionEntity): void {
    // 	if (this._scene == scene)
    // 		return;
    // 	this._scene = scene;
    // 	const len: number = this._children.length;
    // 	for (let i: number = 0; i < len; ++i)
    // 		this._children[i]._setScene(scene);
    // }
    PartitionBase.prototype.requestAbstraction = function (asset) {
        return PartitionBase._abstractionClassPool[asset.assetType];
    };
    /**
     *
     * @param imageObjectClass
     */
    PartitionBase.registerAbstraction = function (abstractionClass, assetClass) {
        PartitionBase._abstractionClassPool[assetClass.assetType] = abstractionClass;
    };
    PartitionBase._abstractionClassPool = {};
    return PartitionBase;
}(AssetBase));
export { PartitionBase };
